import axios from "axios";

/** Skip retrying deterministic 4xx responses (auth, validation, route
 *  doesn't exist). Only transient 5xx / network failures get one retry. */
export const retryOnTransientErrors = (
  failureCount: number,
  error: Error,
): boolean => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (typeof status === "number" && status >= 400 && status < 500) {
      return false;
    }
  }

  return failureCount < 1;
};
